import { AgTechTourConfig } from '@agtech/web/components/App/Tour/AgTechTourTypes'

// The Team tab is only rendered for users with 'operation.users.view', so its step is opt-in.
// Targeting a tab that isn't in the DOM would leave the tour dimming the whole screen.
export const getSaleSettingsViewDialogTourConfig = (options: { includeTeamTab: boolean }): AgTechTourConfig => ({
    id: 'sale-settings-view-dialog-tour',
    name: 'My Sale Settings Tour',
    steps: [
        {
            targetId: 'sale-settings-lot-categories-tab',
            title: 'Lot Categories',
            description: 'Create and manage lot categories used to organize and classify lots across your sales.',
            position: 'right',
            onActivate: () => document.getElementById('sale-settings-lot-categories-tab')?.click(),
        },
        {
            targetId: 'sale-settings-charges-discounts-tab',
            title: 'Charges and Discounts',
            description: 'Configure invoice modifiers such as buyer\'s premiums, fees, and discounts that apply to invoices.',
            position: 'right',
            onActivate: () => document.getElementById('sale-settings-charges-discounts-tab')?.click(),
        },
        {
            targetId: 'sale-settings-task-templates-tab',
            title: 'Task Templates',
            description: 'Build reusable sets of planning tasks. Apply a template from the Planning Tasks tab to add all of its tasks to a sale at once.',
            position: 'right',
            onActivate: () => document.getElementById('sale-settings-task-templates-tab')?.click(),
        },
        {
            targetId: 'sale-settings-document-headers-tab',
            title: 'Document Headers',
            description: 'Set up the header content that appears at the top of printed documents like sale bills and invoices.',
            position: 'right',
            onActivate: () => document.getElementById('sale-settings-document-headers-tab')?.click(),
        },
        {
            targetId: 'sale-settings-invoice-fields-tab',
            title: 'Invoice Fields',
            description: 'Control which fields are shown on generated invoice documents.',
            position: 'right',
            onActivate: () => document.getElementById('sale-settings-invoice-fields-tab')?.click(),
        },
        {
            targetId: 'sale-settings-logo-tab',
            title: 'Logo',
            description: 'Upload and manage your operation\'s logo, which appears on printed documents.',
            position: 'right',
            onActivate: () => document.getElementById('sale-settings-logo-tab')?.click(),
        },
        ...(options.includeTeamTab ? [{
            targetId: 'sale-settings-team-tab',
            title: 'Team',
            description: 'See everyone on your operation and the roles they hold. Use the row menu to change a team member\'s roles.',
            position: 'right' as const,
            onActivate: () => document.getElementById('sale-settings-team-tab')?.click(),
        }] : []),
    ]
})
